/**
 * Step Output Panel Size Constants
 *
 * These constants define the default, minimum, and maximum sizes
 * for the resizable panels in the step output component.
 */

/**
 * Default size for the Raw output panel (percentage)
 */
export const RAW_PANEL_DEFAULT_SIZE = 60;

/**
 * Default size for the Filtered output panel (percentage)
 */
export const FILTERED_PANEL_DEFAULT_SIZE = 40;

/**
 * Minimum size for any panel (percentage)
 */
export const PANEL_MIN_SIZE = 25;

/**
 * Maximum size for the Filtered panel (percentage)
 */
export const FILTERED_PANEL_MAX_SIZE = 75;

/**
 * Step Dialog Panel Size Constants
 *
 * These constants define the default, minimum, and maximum sizes
 * for the three resizable panels in the step configuration dialog
 * (Input, Config Form, Output).
 */

/**
 * Default size for the left panel (Step Input) - percentage
 */
export const STEP_DIALOG_LEFT_PANEL_DEFAULT_SIZE = 30;

/**
 * Default size for the middle panel (Config Form) - percentage
 */
export const STEP_DIALOG_MIDDLE_PANEL_DEFAULT_SIZE = 40;

/**
 * Default size for the right panel (Step Output) - percentage
 */
export const STEP_DIALOG_RIGHT_PANEL_DEFAULT_SIZE = 30;

/**
 * Minimum size for side panels (Input and Output) - percentage
 */
export const STEP_DIALOG_SIDE_PANEL_MIN_SIZE = 20;

/**
 * Maximum size for side panels (Input and Output) - percentage
 */
export const STEP_DIALOG_SIDE_PANEL_MAX_SIZE = 60;

/**
 * Minimum size for middle panel (Config Form) - percentage
 */
export const STEP_DIALOG_MIDDLE_PANEL_MIN_SIZE = 25;

/**
 * Width class for the panel content
 */
export const STEP_DIALOG_PANEL_CONTENT_WIDTH_CLASS =
  "w-full! max-w-full! min-w-xs!";
